module.exports = __webpack_public_path__ + "img/engineering1.61c92d03.jpg";